/*
  Some lint rules disabled for this file, so the map style can be saved in valid
  JSON format for easy copying and pasting to Snazzy Maps.
*/
export const OFFER_SUMMARY_MAP_HEIGHT = 196

export const PROPERTY_MAP_MARKER_TYPE = 'property'
export const NEARBY_MAP_MARKER_TYPE = 'nearby'
export const CRUISE_PILL_MARKER_TYPE = 'cruise-pill'
export const CRUISE_PILL_ICON_MARKER_TYPE = 'cruise-pill-icon'
export const MOMENTS_MAP_MARKER_TYPE = 'moments'
